import { Modal } from "../Modal";
import { mainStore } from "../../mainStore";
import { translationService } from "../../translationService";
import { currencySymbols } from "../../constants/currencySymbols";

export const InfoSection = () => {
  const { t, TKeys } = translationService;
  return (
    <Modal onClose={() => mainStore.setInfoSectionOpened(false)} title={t(TKeys.INFO_SECTION)}>
      {/*<p style={{color: 'whitesmoke'}}>{t(TKeys.INFO_SECTION_DESCRIPTION)}</p>*/}
      <div
        style={{ color: "whitesmoke", marginTop: "1em" }}
        dangerouslySetInnerHTML={{
          __html: t(
            TKeys.INFO_SECTION_DESCRIPTION,
            `${currencySymbols[mainStore.currency]}${mainStore.minBet}`,
            `${currencySymbols[mainStore.currency]}${mainStore.maxBet}`,
            `${currencySymbols[mainStore.currency]}${mainStore.maxWin}`
          ),
        }}
      ></div>
    </Modal>
  );
};
